<template>
  <div>
    <div class="position-relative new-bet-slip">
      <div class="bottom-menu-wrapper d-block d-lg-none" v-if="!isPartialLoading">
        <div class="bet-slip-mobile-menu-wrapper" :class="{ show: betSlipOpened }">
          <bet-slip class="bet-slip-wrapper" />
        </div>

        <div class="bottom-menu">
          <ul
            class="menu-list"
            :class="{
              'menu-list-bet-slip-active': betSlipOpened,
            }"
          >
            <li @click="closeBetSlip()">
              <router-link class="link" to="/sports">
                <i class="icon icon-all-sport"></i>
                {{ $t('Menu.Sportsbook') }}
              </router-link>
            </li>

            <li v-if="shouldDisableCasino && !isScanningCodeForMobile" @click="closeBetSlip">
              <router-link class="link" to="/contact-us">
                <i class="icon icon-contact"></i>
                {{ $t('Menu.Contact Us') }}
              </router-link>
            </li>
            <li v-else-if='!isScanningCodeForMobile' @click="closeBetSlip()">
              <router-link class="link" to="/casino">
                <i class="icon icon-casino"></i>
                {{ $t('Menu.Casino') }}
              </router-link>
            </li>
            <li class="bet-slip-link" v-if="activeBetSlip">
              <span
                class="link"
                @click="toggleBetSlip"
                :class="{
                  'bet-slip-active': betSlipOpened,
                }"
              >
                <img src="@/assets/images/bet-slip-count.png" class="bet-link-icon" alt />
                <span
                  class="bet-count"
                  :class="{ 'betslip-icon-anim': applyBetSlipIconAnim }"
                  v-if="betSlipBetsCount > 0"
                  >{{ betSlipBetsCount }}</span
                >
                <span style="position: relative;bottom: -8px;">{{ $t('Menu.BetSlip') }}</span>
              </span>
            </li>

            <li v-if="!isScanningCodeForMobile" @click="closeBetSlip()">
              <router-link class="link" to="/bonus">
                <i class="icon icon-bonuses"></i>
                {{ $t('Menu.Bonuses') }}
              </router-link>
            </li>
            <li v-if="!isScanningCodeForMobile" @click="closeBetSlip()">
              <span
                class="link"
                :class="{
                  'router-link-exact-active router-link-active': isDepositPage,
                }"
                @click="$emit('goIfLogged', isClerk ? '/clerk/deposit/' : '/deposit/')"
              >
                <i class="icon icon-deposit"></i>
                {{ $t('Menu.Deposit') }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import BetSlip from '@/views/sports/components/BetSlip';
import snq from 'snq';

export default {
  name: 'BottomMenu',
  components: { BetSlip },
  props: ['isPartialLoading', 'shouldDisableCasino', 'isClerk'],
  data() {
    return {
      applyBetSlipIconAnim: false,
      isDepositPage: false,
      activeBetSlip: false,
    };
  },
  computed: {
    ...mapState({
      freeWagersViewing: state => state.freeWagerStore.freeWagersViewing,
      betSlipBetCount: state => state.betSlip.betSlipBetCount,
      selectedFreeWager: state => state.freeWagerStore.selectedFreeWager,
      betSlipOpened: state => state.betSlip.betSlipOpened,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    betSlipBetsCount() {
      if (this.freeWagersViewing) {
        return Math.min(this.betSlipBetCount, this.selectedFreeWager.pick_count);
      }
      return this.betSlipBetCount;
    },
  },
  watch: {
    $route(val) {
      const isDeposit = snq(() => val.matched.some(item => item.name === 'deposit'));
      this.setIsDepositPage(isDeposit);
      if (this.$route.path.includes('sports')) {
        this.activeBetSlip = true;
      } else {
        this.activeBetSlip = false;
      }
    },
    betSlipBetsCount(value, oldValue) {
      if (oldValue != value) {
        this.applyBetSlipIconAnim = true;
        setTimeout(() => {
          this.applyBetSlipIconAnim = false;
        }, 1000);
      }
    },
    betSlipOpened(value) {
      const isDesktop = document.documentElement.classList.contains('ua-desktop');
      if (isDesktop) return;
      if (value === true) {
        document.documentElement.classList.add('no-scroll');
        document.body.classList.add('no-scroll');
      } else {
        document.documentElement.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll');
      }
    },
  },
  methods: {
    ...mapMutations({
      toggleBetSlip: 'betSlip/toggleBetSlip',
    }),
    closeBetSlip() {
      this.$store.commit('betSlip/closeBetSlip');
    },
    setIsDepositPage(val) {
      this.isDepositPage = val;
    },
  },
  created() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', function() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    if (window.location.href.includes('/deposit')) {
      this.setIsDepositPage(true);
    }
    if (this.$route.path.includes('sports')) {
      this.activeBetSlip = true;
    } else {
      this.activeBetSlip = false;
    }
  },
};
</script>

<style lang="scss">
.bet-slip-mobile-menu-wrapper {
  height: calc(var(--vh, 1vh) * 100);
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0;
  z-index: 90;
  overflow-y: scroll;
  display: none;
  background-color: white;
  padding-top: 50px;
  padding-bottom: 52px;

  &.show {
    display: block;
  }

  .bet-slip-wrapper {
    padding: 0 10px;
    width: 100%;
    z-index: 91;
    position: relative;
    top: 0px;
  }
  .total-amounts-wrapper {
    // margin-bottom: 70px;
  }
}

body.no-scroll {
  overflow: hidden;
  position: relative;
  height: 100%;
}
</style>
